import { Dispatch, SetStateAction, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { DayPicker, DateRange } from 'react-day-picker'
import 'react-day-picker/dist/style.css'
import logoImg from '../../assets/images/logos/ai-measure-logo-black.svg'
import searchIcon from '../../assets/images/icons/search-icon.svg'
import logoutIcon from '../../assets/images/icons/logout-icon.svg'
import toyoshimaLogo from '../../assets/images/logos/toyoshima-hd.svg'
import downArrowIcon from '../../assets/images/icons/downArrow.svg'
import upArrowIcon from '../../assets/images/icons/upArrow.svg'
import qrLittleIcon from '../../assets/images/icons/littleQr.svg'
import infoIcon from '../../assets/images/icons/info-outline.svg'
import checkIcon from '../../assets/images/icons/checkGreen.svg'
import checkboxIcon from '../../assets/images/icons/checked_checkbox.svg'
import uncheckIcon from '../../assets/images/icons/uncheck_checkbox.svg'
import filterDownIcon from '../../assets/images/icons/arrow-down.svg'
import humanIcon from '../../assets/images/icons/human.svg'
import { Modal } from '../../components/Modal'
import { useNavigate } from 'react-router-dom'
import { buildSamplePath, formatOrdinal, PATH_INFO, sortSamplesByCreatedAtDesc, toSafeSampleIdPathSegment } from '../utils/helper'
import isEqual from 'lodash/isEqual'
import { fetchDepartmentSamples, SamplesContext, SamplesMeta, SamplesResponseType, SAMPLES_PAGE_LIMIT, UpdateSamplesContext } from '../../context/samplesContext'
import { UpdateUserContext, UserContext } from '../../context/userContext'
import { UpdateAuthContext } from '../../context/authContext'
import { format, parse, parseISO } from 'date-fns'
import { FilterInput } from '../../components/input/FilterInput'
import { FilterParams } from '../../context/samplesContext'
import { ja } from 'date-fns/locale'
import InfiniteScroll from 'react-infinite-scroll-component'
import ReactLoading from 'react-loading'
import downloadIcon from '../../assets/images/icons/bulk-csv-download.svg'
import { extractFileNameFromHeader } from '../Specification-download/helpers'
import { clientFetch } from '../../utils/clientFetch'
import { notifyApiError, notifyHttpError } from '../../utils/apiErrorHandler'
import { useCanEdit } from '../../hooks/useCanEdit'
import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from '../../components/LanguageSwitcher'

export function Header() {
  const { t } = useTranslation()
  const { user, isAuth } = useContext(UserContext)
  const { refreshUser } = useContext(UpdateUserContext)
  const { logout } = useContext(UpdateAuthContext)
  const [isOpen, setIsOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const closeModal = useCallback(() => { setIsModalOpen(false) }, [])
  const [isSmall, setIsSmall] = useState(false)

  const onLogout = useCallback(async () => {
    await logout()
  }, [logout])

  useEffect(() => { refreshUser() }, [refreshUser])

  useEffect(() => {
    const media = window.matchMedia("(max-width: 920px)") //"tablet-lg": "920px",
    const listener = () => setIsSmall(media.matches)

    listener()
    media.addEventListener('change', listener)

    return () => media.removeEventListener('change', listener)
  }, [])

  useEffect(() => {
    if (isSmall && isOpen) {
      const originalOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      return () => {
        document.body.style.overflow = originalOverflow
      }
    }
    document.body.style.overflow = ''
  }, [isSmall, isOpen])

  return (
    <div className="flex justify-between items-center h-[50px] px-5 min-w-[768px] bg-[linear-gradient(90deg,_#9E7BDB_0%,_#8C92D6_61%,_#74C8CC_100%)] sticky top-0 z-40 desktop-xmd:relative tablet-lg:px-10 tablet-lg:h-[70px]">
      <img src={logoImg} alt='logo' className='h-[34px] tablet-lg:h-[48px]' />
      <div className='flex space-x-[15px] items-center'>
        <div className='bg-white w-[356px] h-[36px] rounded-[50px] tablet-lg:h-[50px]'>
          <button
            onClick={() => { isAuth && setIsModalOpen(true) }}
            className={`flex items-center justify-between pl-[20px] w-full h-full ${!isAuth && 'cursor-not-allowed'}`}
          >
            <span className='text-gray-400 text-[14px]'>{t("sample.partNumber")}</span>
            <span className='flex justify-center items-center bg-black h-[30px] w-[30px] rounded-[50%] mr-[5px] select-none tablet-lg:w-[40px] tablet-lg:h-[40px]'>
              <img src={searchIcon} alt='' className='w-4 h-4 tablet-lg:h-5 tablet-lg:w-5' />
            </span>
          </button>
        </div>
        {isSmall ? (
          <div>
            <div
              className='flex items-center justify-center w-[30px] h-[30px] bg-black rounded-[50%]'
              onClick={() => { if (isAuth) setIsOpen((prev) => !prev) }}
            >
              <img src={humanIcon} alt='human' />
            </div>
            {isOpen && (
              <div
                className='fixed top-[50px] left-0 right-0 bottom-0 bg-black/50 z-[999]'
                onClick={() => setIsOpen(false)}
              >
                <div
                  className='absolute top-[10px] right-5 bg-white rounded-lg shadow-[0px_6px_12px_rgba(0,0,0,0.25)] w-[225px] h-[318px]'
                  onClick={(event) => event.stopPropagation()}
                >
                  <div className='flex flex-col items-center w-full h-full px-2.5 pt-[30px] text-xs'>
                    <p className='w-full text-center truncate'>{user.email}</p>
                    <p className='w-full text-center truncate'>{user.department_name}</p>
                    <div className="flex flex-col mt-4">
                      <button onClick={onLogout} className='flex items-center w-[205px] h-[42px] rounded-[3px] mt-[10px]' style={{ boxShadow: ' 0px 0px 4px 0px #00000040' }}>
                        <img src={logoutIcon} alt='logout' className='w-[32px] h-[32px] ml-[10px]' />
                        <span className='ml-[5px] text-base'>{t("common.logout")}</span>
                      </button>
                    </div>
                    <div className="flex flex-col items-center gap-[14px] mt-auto mb-[18px]">
                      <LanguageSwitcher />
                      <img src={toyoshimaLogo} alt="Logo" />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className={`relative inline-block bg-white w-[270px] h-[50px] z-20 select-none ${isOpen ? 'rounded-t-[5px]' : 'rounded-[5px]'}`}>
            <div
              className={`flex items-center justify-between w-full h-full pl-[10px] pr-[20px] ${isAuth ? 'cursor-pointer' : 'cursor-not-allowed'}`}
              onClick={() => { if (isAuth) setIsOpen((prev) => !prev) }}
            >
              <div className='w-[200px]'>
                <p className="text-[14px] truncate">{user.email}</p>
                <p className='text-[12px] truncate'>{user.department_name}</p>
              </div>
              {isOpen ? (<img src={upArrowIcon} alt='arrow' />) : (<img src={downArrowIcon} alt='arrow' />)}
            </div>
            {isOpen && (
              <div className="absolute flex flex-col items-center justify-between top-full left-0 bg-white z-10 w-[270px] h-[270px] rounded-b-[5px]" style={{ boxShadow: ' 0px 6px 4px 0px #00000040' }}>
                <div className="flex flex-col">
                  <span className='border-t-[1px] border-[#F3F3F3] w-[250px]'></span>
                  <button onClick={onLogout} className='flex items-center w-[250px] h-[50px] rounded-[3px] mt-[10px]' style={{ boxShadow: ' 0px 0px 4px 0px #00000040' }}>
                    <img src={logoutIcon} alt='logout' className='w-[32px] h-[32px] ml-[10px]' />
                    <span className='ml-[5px]'>{t("common.logout")}</span>
                  </button>
                </div>
                <div className="flex flex-col items-center gap-[14px] mb-[28px]">
                  <LanguageSwitcher />
                  <img src={toyoshimaLogo} alt="Logo" />
                </div>
              </div>
            )}
          </div>)}
      </div>
      <SearchModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  )
}

// モーダル内スクロール領域の識別子（検索/一括CSV）
const SEARCH_MODAL_SCROLL_ID = "search-modal-scroll-container"
const CSV_BULK_MODAL_SCROLL_ID = "csv-bulk-modal-scroll-container"
// 一括エクスポートの既定ファイル名と制限・タイムアウト
const DEFAULT_BULK_MEASUREMENT_EXPORT_FILE_NAME = "measurement-exports.zip"
const MAX_BULK_MEASUREMENT_EXPORT_COUNT = 100
const MINUTE_IN_MS = 60 * 1000
const CSV_DOWNLOAD_TIMEOUT_MINUTES = 15
const CSV_DOWNLOAD_TIMEOUT_MS = CSV_DOWNLOAD_TIMEOUT_MINUTES * MINUTE_IN_MS
// Content-Length不一致などの汎用エラーメッセージ
const INVALID_CONTENT_LENGTH_MESSAGE_KEY = "messages.downloadFailedRetry"
// tooltipの設定
const TOOLTIP_OFFSET_PX = 8
const TOOLTIP_HEIGHT_PX = 92
type DateParts = { datePart: string; timePart?: string }
type DepartmentOption = {
  id: number
  name: string
}

type FilterDraftState = {
  userName: string
  partNumber: string
  sampleStatus: string
  brandName: string
  size: string
  colorNo: string
  selectedDepartmentId: string
  departmentName: string
  range?: DateRange
}

const INITIAL_FILTER_DRAFT: FilterDraftState = {
  userName: '',
  partNumber: '',
  sampleStatus: '',
  brandName: '',
  size: '',
  colorNo: '',
  selectedDepartmentId: '',
  departmentName: '',
  range: undefined
}

const normalizeDepartmentOptions = (value: unknown): DepartmentOption[] => {
  if (!Array.isArray(value)) {
    return []
  }

  return value.flatMap((item) => {
    if (!item || typeof item !== 'object') {
      return []
    }

    const record = item as { id?: unknown; name?: unknown }
    const departmentId = Number(record.id)
    const departmentName = typeof record.name === 'string' ? record.name.trim() : ''
    if (!Number.isInteger(departmentId) || departmentId <= 0 || departmentName === '') {
      return []
    }

    return [{ id: departmentId, name: departmentName }]
  })
}

const parseDepartmentIdFilter = (value: string) => {
  const parsed = Number.parseInt(value, 10)
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return undefined
  }
  return parsed
}

const formatSampleDateParts = (value?: string | null): DateParts | null => {
  if (!value) {
    return null
  }
  try {
    const formatted = format(parseISO(value), 'yyyy/MM/dd HH:mm', { locale: ja })
    const [datePart, timePart] = formatted.split(' ')
    return { datePart, timePart }
  } catch (error) {
    console.error('Failed to format sample date', error)
    return null
  }
}

function SampleDateContent({ value }: { value?: string | null }) {
  const parts = formatSampleDateParts(value)
  if (!parts) {
    return <>-</>
  }
  return (
    <span className='flex flex-col items-center justify-center leading-tight desktop-xmd:flex-row desktop-xmd:space-x-1 desktop-xmd:leading-normal'>
      <span className='whitespace-nowrap'>{parts.datePart}</span>
      {parts.timePart && <span className='whitespace-nowrap'>{parts.timePart}</span>}
    </span>
  )
}

function SampleDeviceContent({ deviceName, deviceLocation }: { deviceName?: string | null, deviceLocation?: string | null }) {
  if (!deviceName && !deviceLocation) {
    return <>-</>
  }
  return (
    <span className='flex flex-wrap justify-center gap-x-1 text-center w-full'>
      {deviceName && <span className='break-all'>{deviceName}</span>}
      {deviceLocation && (
        <span className='break-all text-[10px]'>{`(${deviceLocation})`}</span>
      )}
    </span>
  )
}

function SearchModal({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { isAuth } = useContext(UserContext)
  const { samples, sample, rowSample, samplesMeta } = useContext(SamplesContext)
  const { refreshSamples, loadMoreSamples, fetchQrCode } = useContext(UpdateSamplesContext)
  const { isAdmin } = useCanEdit()
  const [filterDraft, setFilterDraft] = useState<FilterDraftState>(INITIAL_FILTER_DRAFT)
  const [csvFilterDraft, setCsvFilterDraft] = useState<FilterDraftState>(INITIAL_FILTER_DRAFT)
  const [csvAppliedFilters, setCsvAppliedFilters] = useState<FilterParams | undefined>(undefined)
  const [selectIndex, setSelectIndex] = useState<number>()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = useCallback(() => { setIsModalOpen(true) }, [])
  const closeModal = useCallback(() => { setIsModalOpen(false) }, [])
  const [qrCodeUrl, setQrCodeUrl] = useState({ qr_code: '', url: '', id: '' })
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const openConfirmModal = useCallback(() => { setIsConfirmModalOpen(true) }, [])
  const closeConfirmModal = useCallback(() => { setIsConfirmModalOpen(false) }, [])
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
  const openFilterModal = useCallback(() => { setIsFilterModalOpen(true) }, [])
  const closeFilterModal = useCallback(() => { setIsFilterModalOpen(false) }, [])
  const [isCsvDownloadModalOpen, setIsCsvDownloadModalOpen] = useState(false)
  const openCsvDownloadModal = useCallback(() => { setIsCsvDownloadModalOpen(true) }, [])
  const closeCsvDownloadModal = useCallback(() => { setIsCsvDownloadModalOpen(false) }, [])

  const sortedSamples = useMemo(() => sortSamplesByCreatedAtDesc(samples), [samples])

  useEffect(() => {
    if (!isAuth) return
    refreshSamples()
  }, [refreshSamples, isAuth])

  const onSetItem = useCallback(() => {
    if (selectIndex === undefined || samples === undefined) return
    const targetSample = sortedSamples[selectIndex]
    if (!targetSample?.id) return
    navigate(buildSamplePath(targetSample.id))
    onClose()
  }, [sortedSamples, samples, selectIndex, onClose, navigate])

  const handleSetItem = useCallback(() => {
    if (sample || rowSample) {
      const hasChanged = !isEqual(sample, rowSample)
      if (hasChanged) {
        openConfirmModal()
        return
      }
    }
    onSetItem()
  }, [onSetItem, openConfirmModal, rowSample, sample])

  const handleApplyFilter = useCallback((filters: FilterParams) => {
    refreshSamples(filters);
    closeFilterModal();
  }, [refreshSamples, closeFilterModal]);

  const handleShowQrCode = useCallback(async (sampleId: string) => {
    const qrData = await fetchQrCode(sampleId);
    if (qrData) {
      setQrCodeUrl(qrData);
      openModal();
    }
    // エラーの場合は fetchQrCode 内でコンソールに出力される
  }, [fetchQrCode, openModal]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-[1266px] px-[21px] pt-[14px] pb-[30px] max-h-[90vh] flex flex-col'>
      <div className='flex items-center w-full'>
        <div className='w-2 h-[35px] rounded-sm bg-[#3E3E3E] mr-[5px]' ></div>
        <span className='text-[#3E3E3E] text-[16px]'>
          {t("sample.partNumber")}
        </span>
      </div>
      <div className='flex justify-end w-full mt-[20px] space-x-2'>
        <button
          onClick={openFilterModal}
          className='flex items-center justify-center w-[160px] h-[47px] border-[2px] border-[#C5C7FF] rounded-[50px] hover:bg-[#C5C7FF] transition-colors'
        >
          <img src={filterDownIcon} alt='sort' className='w-[22px] h-[22px] mr-[5px]' />
          <span className='font-semibold text-[14px] text-[#545899]'>{t("actions.filter")}</span>
        </button>
        <button
          onClick={openCsvDownloadModal}
          className='flex items-center justify-center w-[230px] h-[47px] border-[2px] border-[#C5C7FF] rounded-[50px] hover:bg-[#C5C7FF] transition-colors'
        >
          <img src={downloadIcon} alt="download" className='w-[22px] h-[22px] mr-[5px]' />
          <span className='font-semibold text-[14px] text-[#545899]'>{t("actions.bulkCsvDownload")}</span>
        </button>
      </div>
      <div
        id={SEARCH_MODAL_SCROLL_ID}
        className='flex-1 min-h-0 max-h-[650px] overflow-y-scroll mt-[20px] border-b'
      >
        <InfiniteScroll
          dataLength={sortedSamples?.length ?? 0}
          next={loadMoreSamples}
          hasMore={samplesMeta.hasMore}
          loader={
            <div className='flex items-center justify-center py-3 text-center text-xs text-[#666666]'>
              <ReactLoading type='spin' color='#666666' height={16} width={16} className='inline-block mr-2' />
              <span>{t("common.loadingWithDots")}</span>
            </div>
          }
          endMessage={<div className='py-3 text-center text-xs text-[#666666]'>{t("messages.allDataLoaded")}</div>}
          scrollableTarget={SEARCH_MODAL_SCROLL_ID}
          scrollThreshold='200px'
          style={{ overflow: 'visible' }}
        >
          <table className='w-full h-full overflow-auto text-[#666666]'>
            <thead className='sticky top-0'>
              <tr className='[&>th]:bg-[#3E3E3E] [&>th]:text-white [&>th]:font-normal [&>th]:text-xs [&>th]:border desktop-xmd:[&>th]:text-sm'>
                <th className='sticky top-0 w-[43px] h-[39px]'>No</th>
                <th className='sticky top-0 w-[88px]'>{t("common.select")}</th>
                <th className='sticky top-0 w-[145px]'>{t("sample.date")}</th>
                <th className='sticky top-0 w-[145px]'>{t("sample.partNumber")}</th>
                <th className='sticky top-0 w-[173px]'>{t("sample.sampleNumber")}</th>
                <th className='sticky top-0 w-[173px]'>{t("sample.sampleStatus")}</th>
                <th className='sticky top-0 w-[100px]'>{t("sample.repeat")}</th>
                <th className='sticky top-0 w-[100px]'>{t("sample.size")}</th>
                <th className='sticky top-0 w-[130px]'>{t("sample.colorNo")}</th>
                {isAdmin && <th className='sticky top-0 w-[145px]'>{t("sample.department")}</th>}
                <th className='sticky top-0 w-[130px]'>{t("sample.deviceName")}</th>
                <th className='sticky top-0 w-[145px]'>{t("sample.qrConfirmation")}</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(samples) && sortedSamples?.map((sample, index) => (
                <tr key={index}>
                  <td className='h-[35px] border text-center'>{index + 1}</td>
                  <td className='border'>
                    <div className='flex items-center justify-center w-full h-full'>
                      <label className='cursor-pointer'>
                        <input
                          type="radio"
                          name='check'
                          className='hidden peer'
                          onChange={() => setSelectIndex(index)}
                        />
                        <img src={uncheckIcon} alt='uncheck' className='block peer-checked:hidden w-4 h-4 desktop-xmd:w-5 desktop-xmd:h-5' />
                        <img src={checkboxIcon} alt='checked' className='hidden peer-checked:block w-4 h-4 desktop-xmd:w-5 desktop-xmd:h-5' />
                      </label>
                    </div>
                  </td>
                  <td className='border text-xs text-center px-1 desktop-xmd:text-sm'>
                    <SampleDateContent value={sample.created_at} />
                  </td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.part_number || '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.sample_number || '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.kind === 'final' ? 'FINAL' : sample.time !== 0 ? formatOrdinal(sample.time) : '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.repeat || '-'}</td>
                  <td className='border text-[16px] text-center px-1 break-words break-all'>{sample.size || '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.color_no || '-'}</td>
                  {isAdmin && (
                    <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.department_name || '-'}</td>
                  )}
                  <td className='border text-xs text-center px-1 w-[130px] break-words break-all desktop-xmd:text-sm'>
                    <SampleDeviceContent deviceName={sample.device_name} deviceLocation={sample.device_location} />
                  </td>
                  <td className='border'>
                    <div className='flex items-center justify-center w-full h-full'>
                      <button
                        className='flex items-center justify-center w-[90px] h-[27px] rounded-[50px] bg-[#8A8A8A]'
                        onClick={() => handleShowQrCode(sample.id)}
                      >
                        <img src={qrLittleIcon} alt='qr' className='w-[12px]' />
                        <span className='text-white text-[11px] -mt-[2px] ml-[2px]'>{t("actions.qrDisplay")}</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              <tr>
                <td className='border h-full'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                {isAdmin && <td className='border'></td>}
                <td className='border-b'></td>
                <td className='border-x border-b'></td>
              </tr>
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
      <div className='flex items-center justify-center w-full space-x-[10px] mt-[20px]'>
        <button
          className='w-[160px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] font-semibold text-[14px]'
          onClick={onClose}
        >
          {t("common.back")}</button>
        <button
          className='w-[160px] h-[47px] bg-[#C5C7FF] rounded-[50px] text-[#545899] font-semibold text-[14px]'
          onClick={handleSetItem}
        >
          {t("actions.measurementDisplay")}
        </button>
      </div>
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={closeFilterModal}
        onApplyFilter={handleApplyFilter}
        draft={filterDraft}
        setDraft={setFilterDraft}
      />
      <QrCordModal isOpen={isModalOpen} onClose={closeModal} qrCodeUrl={qrCodeUrl} />
      <ConfirmModal isOpen={isConfirmModalOpen} onClose={closeConfirmModal} onSetItem={onSetItem} />
      <CsvBulkDownloadModal
        isOpen={isCsvDownloadModalOpen}
        onClose={closeCsvDownloadModal}
        filterDraft={csvFilterDraft}
        setFilterDraft={setCsvFilterDraft}
        appliedFilters={csvAppliedFilters}
        setAppliedFilters={setCsvAppliedFilters}
      />
    </Modal>
  )
}

type FilterModalProps = {
  isOpen: boolean
  onClose: () => void
  onApplyFilter: (filters: FilterParams) => void
  draft: FilterDraftState
  setDraft: Dispatch<SetStateAction<FilterDraftState>>
}

type FilterTextKey = 'userName' | 'partNumber' | 'sampleStatus' | 'brandName' | 'size' | 'colorNo' | 'departmentName'

function FilterModal({ isOpen, onClose, onApplyFilter, draft, setDraft }: FilterModalProps) {
  const { t } = useTranslation()
  const { isAdmin } = useCanEdit()
  const { range, userName, partNumber, sampleStatus, brandName, size, colorNo, selectedDepartmentId, departmentName } = draft
  const partNumberInputRef = useRef<HTMLInputElement>(null)
  const [departmentOptions, setDepartmentOptions] = useState<DepartmentOption[]>([])
  const [isDepartmentOptionsLoading, setIsDepartmentOptionsLoading] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      return
    }
    const id = window.requestAnimationFrame(() => {
      partNumberInputRef.current?.focus()
    })
    return () => window.cancelAnimationFrame(id)
  }, [isOpen])

  useEffect(() => {
    if (!isOpen || !isAdmin) {
      return
    }

    const abortController = new AbortController()

    const loadDepartmentOptions = async () => {
      try {
        setIsDepartmentOptionsLoading(true)

        const res = await clientFetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/client/departments`, {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
          },
          signal: abortController.signal
        })

        if (!res.ok) {
          notifyHttpError(res, { logMessage: '部署一覧の取得に失敗しました。' })
          if (abortController.signal.aborted) {
            return
          }
          setDepartmentOptions([])
          setDraft((prev) => {
            if (prev.selectedDepartmentId === '') {
              return prev
            }
            return { ...prev, selectedDepartmentId: '' }
          })
          return
        }

        const data = await res.json()
        const nextOptions = normalizeDepartmentOptions(data)
        if (abortController.signal.aborted) {
          return
        }

        setDepartmentOptions(nextOptions)
        setDraft((prev) => {
          if (prev.selectedDepartmentId === '') {
            return prev
          }
          const hasSelectedDepartment = nextOptions.some((option) => String(option.id) === prev.selectedDepartmentId)
          if (hasSelectedDepartment) {
            return prev
          }
          return { ...prev, selectedDepartmentId: '' }
        })
      } catch (error) {
        if (abortController.signal.aborted) {
          return
        }
        notifyApiError({ error, logMessage: '部署一覧の取得に失敗しました。' })
        setDepartmentOptions([])
        setDraft((prev) => {
          if (prev.selectedDepartmentId === '') {
            return prev
          }
          return { ...prev, selectedDepartmentId: '' }
        })
      } finally {
        if (!abortController.signal.aborted) {
          setIsDepartmentOptionsLoading(false)
        }
      }
    }

    loadDepartmentOptions()

    return () => {
      abortController.abort()
    }
  }, [isOpen, isAdmin, setDraft])

  const setFilterTextValue = useCallback((key: FilterTextKey, value: string) => {
    setDraft((prev) => ({ ...prev, [key]: value }))
  }, [setDraft])

  const handleDepartmentSelectChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    const nextDepartmentId = e.target.value
    setDraft((prev) => ({
      ...prev,
      selectedDepartmentId: nextDepartmentId,
      departmentName: nextDepartmentId === '' ? prev.departmentName : ''
    }))
  }, [setDraft])

  const handleDepartmentNameChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const nextDepartmentName = e.target.value
    setDraft((prev) => ({
      ...prev,
      departmentName: nextDepartmentName,
      selectedDepartmentId: nextDepartmentName.trim() === '' ? prev.selectedDepartmentId : ''
    }))
  }, [setDraft])

  const handleStartDateChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const date = parse(e.target.value, 'yyyy-MM-dd', new Date())
    if (!isNaN(date.getTime())) {
      setDraft((prev) => ({ ...prev, range: { from: date, to: prev.range?.to } }))
    } else {
      setDraft((prev) => ({ ...prev, range: { from: undefined, to: prev.range?.to } }))
    }
  }, [setDraft])

  const handleEndDateChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const date = parse(e.target.value, 'yyyy-MM-dd', new Date())
    if (!isNaN(date.getTime())) {
      setDraft((prev) => ({ ...prev, range: { from: prev.range?.from, to: date } }))
    } else {
      setDraft((prev) => ({ ...prev, range: { from: prev.range?.from, to: undefined } }))
    }
  }, [setDraft])

  const handleApplyFilter = useCallback(() => {
    const departmentId = parseDepartmentIdFilter(selectedDepartmentId)
    const normalizedDepartmentName = departmentName.trim()
    const departmentNameFilter = departmentId === undefined ? (normalizedDepartmentName || undefined) : undefined
    const filters: FilterParams = {
      userName: userName || undefined,
      partNumber: partNumber || undefined,
      sampleStatus: sampleStatus || undefined,
      brandName: brandName || undefined,
      size: size || undefined,
      colorNo: colorNo || undefined,
      departmentId: isAdmin ? departmentId : undefined,
      departmentName: isAdmin ? departmentNameFilter : undefined,
      createdFrom: range?.from,
      createdTo: range?.to,
    };
    onApplyFilter(filters);
    onClose();
  }, [userName, partNumber, sampleStatus, brandName, size, colorNo, selectedDepartmentId, departmentName, range, onApplyFilter, onClose, isAdmin]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeButtonOrder="last" className='w-[793px] p-[20px] bg-[#FBFBFB] relative max-h-[90vh] overflow-y-auto'>
      <div className='flex flex-col'>
        <div className='flex items-center'>
          <div className='w-2 h-[35px] rounded-sm bg-[#3E3E3E] mr-[5px]' ></div>
          <span className='text-[#3E3E3E] text-[16px]'>
            {t("actions.filterSearch")}
          </span>
        </div>
        <p className='text-sm text-gray-600 mt-[20px] mb-[10px] ml-[20px]'>{t("messages.filterDateNote")}</p>
        <div className='flex flex-row gap-x-[10px] w-full'>
          <div className='w-full order-1'>
            <div className='flex items-center justify-between w-full mb-[10px]'>
              <FilterInput
                type='date'
                value={range?.from ? format(range.from, 'yyyy-MM-dd') : ''}
                onChange={handleStartDateChange}
                width='150'
              />
              <span>-</span>
              <FilterInput
                type='date'
                value={range?.to ? format(range.to, 'yyyy-MM-dd') : ''}
                onChange={handleEndDateChange}
                width='150'
              />
            </div>
            <div className='flex justify-center w-full pt-[15px] px-[15px] pb-[25px] bg-white shadow-[0px_2px_2px_0px_rgba(0,0,0,0.25)] rounded-[8px]' >
              <DayPicker
                mode="range"
                selected={range}
                onSelect={(nextRange) => setDraft((prev) => ({ ...prev, range: nextRange }))}
                numberOfMonths={1}
                navLayout='around'
                formatters={{
                  formatWeekdayName: (date) => format(date, 'EEE').toUpperCase(),
                }}
              />
            </div>
          </div>
          <div className='flex flex-col w-full space-y-[10px] order-2'>
            <FilterInput label={t("sample.partNumber")} placeholder={t("sample.partNumber")} value={partNumber} onChange={(e) => setFilterTextValue('partNumber', e.target.value)} inputRef={partNumberInputRef} />
            <FilterInput label={t("sample.color")} placeholder="color" value={colorNo} onChange={(e) => setFilterTextValue('colorNo', e.target.value)} />
            <FilterInput label={t("sample.size")} placeholder='S/M/L' value={size} onChange={(e) => setFilterTextValue('size', e.target.value)} />
            <FilterInput label={t("sample.customerName")} placeholder={t("sample.customerName")} value={brandName} onChange={(e) => setFilterTextValue('brandName', e.target.value)} />
            <FilterInput label={t("sample.sampleStatus")} placeholder='1st/2nd/3rd' value={sampleStatus} onChange={(e) => setFilterTextValue('sampleStatus', e.target.value)} />
            <FilterInput label={t("sample.user")} placeholder={t("sample.name")} value={userName} onChange={(e) => setFilterTextValue('userName', e.target.value)} />
            {isAdmin && (
              <>
                <label className='w-full'>
                  <span className='text-sm text-gray-600 mb-[4px] block'>{t("sample.departmentDropdown")}</span>
                  <div className='relative'>
                    <select
                      className='w-full h-[33px] px-3 pr-9 text-[12px] bg-white rounded-[8px] border-[1px] border-[#d9d9d9] shadow-[inset_0px_2px_2px_0px_rgba(0,0,0,0.1),0px_2px_2px_0px_rgba(255,255,255,0.15)] appearance-none'
                      value={selectedDepartmentId}
                      onChange={handleDepartmentSelectChange}
                      disabled={isDepartmentOptionsLoading || departmentOptions.length === 0}
                    >
                      <option value=''>
                        {isDepartmentOptionsLoading ? t("sample.departmentLoading") : t("sample.allDepartments")}
                      </option>
                      {departmentOptions.map((option) => (
                        <option key={option.id} value={String(option.id)}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                    <img
                      src={downArrowIcon}
                      alt=''
                      className='pointer-events-none absolute right-3 top-1/2 h-[10px] w-[10px] -translate-y-1/2'
                    />
                  </div>
                </label>
                <FilterInput label={t("sample.departmentFreeInput")} placeholder={t("sample.departmentPartialSearch")} value={departmentName} onChange={handleDepartmentNameChange} />
              </>
            )}
          </div>
        </div>
        <div className='flex justify-end mt-6'>
          <button
            className='w-[160px] h-[47px] flex items-center justify-center space-x-[5px] rounded-[50px] text-[#545899] font-semibold text-[14px] bg-white border-[2px] border-[#C5C7FF] hover:bg-[#C5C7FF] transition-colors'
            onClick={handleApplyFilter}
          >
            <img src={filterDownIcon} alt='' />
            <span>{t("actions.filter")}</span>
          </button>
        </div>
      </div>
    </Modal>
  )
}

function QrCordModal({ isOpen, onClose, qrCodeUrl }: { isOpen: boolean, onClose: () => void, qrCodeUrl: { qr_code: string, url: string, id: string } }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = useCallback(() => { setIsModalOpen(true) }, [])
  const closeModal = useCallback(() => { setIsModalOpen(false) }, [])
  const inputRef = useRef<HTMLInputElement>(null)
  const infoAnchorRef = useRef<HTMLDivElement>(null)
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState<{ top: number, left: number } | null>(null)

  const onCopyUrl = useCallback(async () => {
    if (inputRef.current) {
      inputRef.current.select()
      try {
        await navigator.clipboard.writeText(inputRef.current.value)
      } catch (error) {
        console.error('リンクのコピーに失敗しました。')
      }
      openModal()
    }
  }, [openModal])

  const onQrDownload = useCallback(async (id: string) => {
    const safeSampleId = toSafeSampleIdPathSegment(id)
    if (!safeSampleId) {
      return
    }

    try {
      const res = await clientFetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/client/samples/${safeSampleId}/qr-code/download`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
        },
        handleUnauthorized: true
      })

      if (res.status === 401) {
        return
      }
      if (res.status === 403) {
        navigate(PATH_INFO.LOGIN.PATH)
        return
      }

      if (!res.ok) throw new Error('ダウンロード失敗')

      const blob = await res.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = `qr_${id}.png`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)

      window.URL.revokeObjectURL(downloadUrl)
    } catch (error) {
      console.log('DOWNLOAD ERROR')
    }
  }, [navigate])

  const showTooltip = useCallback(() => {
    const anchor = infoAnchorRef.current
    if (!anchor) return
    const rect = anchor.getBoundingClientRect()
    setTooltipPosition({
      top: rect.top - TOOLTIP_OFFSET_PX - TOOLTIP_HEIGHT_PX,
      left: rect.left + rect.width / 2,
    })
    setIsTooltipOpen(true)
  }, [])

  const hideTooltip = useCallback(() => {
    setIsTooltipOpen(false)
  }, [])

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='flex flex-col items-center w-[485px] h-[90vh] min-h-0 max-h-[620px] pt-5 px-5'>
      <div className='flex items-center w-full'>
        <div className='w-2 h-[35px] rounded-sm bg-[#3E3E3E] mr-[5px]' ></div>
        <span className='text-[#3E3E3E] text-[16px]'>
          QR CODE
        </span>
      </div>
      <div className='flex items-center justify-center min-w-0 max-w-[393px] min-h-0 max-h-[381px] border-[2.5px] border-[#D9D9D9] rounded-[20px] mt-[8px] overflow-hidden'>
        <img src={qrCodeUrl.qr_code} alt='qrcode' className='min-w-0 min-h-0 w-[332px] h-[355px] max-w-full max-h-full object-contain' />
      </div>
      <div className='flex items-center w-[445px] h-[40px] border-[2.5px] border-[#D9D9D9] rounded-[10px] mt-[8px]'>
        <input className='text-[16px] h-full w-full rounded-[10px] px-[18px]' ref={inputRef} value={qrCodeUrl.url} readOnly />
      </div>
      <div className='flex w-full justify-between items-center mt-[28px]'>
        <div
          ref={infoAnchorRef}
          className='relative'
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
        >
          <img src={infoIcon} alt='info' className='w-6 h-6 cursor-help' />
        </div>
        <div className='space-x-[9px] pb-2'>
          <button
            className='w-[105px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] text-[16px] font-semibold'
            onClick={onCopyUrl}
          >
            {t("common.copy")}
          </button>
          <button
            className='w-[160px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] text-[16px] font-semibold'
            onClick={() => { onQrDownload(qrCodeUrl.id) }}
          >
            {t("common.download")}
          </button>
        </div>
      </div>
      {isTooltipOpen && tooltipPosition && createPortal(
        <span
          className='fixed z-[60] flex items-center justify-center w-[446px] h-[92px] px-[19px] bg-white text-[14px] -translate-x-1/2 pointer-events-none'
          style={{
            top: tooltipPosition.top,
            left: tooltipPosition.left,
            boxShadow: '0px 0px 4px 0px #00000040',
          }}
        >
          {t("messages.qrScanGuide")}
        </span>,
        document.body
      )}
      <MessageModal isOpen={isModalOpen} onClose={closeModal} />
    </Modal>
  )
}

function MessageModal({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='flex items-center justify-center w-[414px] h-[130px]'>
      <img src={checkIcon} alt='check' className='w-6 h-6 mr-[5px]' />
      <span className='text-[14px]'>{t("messages.copyLinkSucceeded")}</span>
    </Modal>
  )
}

function ConfirmModal({ isOpen, onClose, onSetItem }: { isOpen: boolean, onClose: () => void, onSetItem: () => void }) {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-[500px] h-[200px] flex flex-col items-center justify-center'>
      <span className='text-center'>
        <p>{t("messages.unsavedChanges")}</p>
        <p>{t("messages.unsavedChangesConfirm")}</p>
      </span>
      <div className='mt-[25px] space-x-[25px]'>
        <button
          className='w-[160px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] font-semibold text-[14px]'
          onClick={onClose}
        >
          {t("common.back")}
        </button>
        <button
          className='w-[160px] h-[47px] bg-[#C5C7FF] rounded-[50px] text-[#545899] font-semibold text-[14px]'
          onClick={() => {
            onSetItem()
            onClose()
          }}
        >
          OK
        </button>
      </div>
    </Modal>
  )
}

type CsvBulkDownloadModalProps = {
  isOpen: boolean
  onClose: () => void
  filterDraft: FilterDraftState
  setFilterDraft: Dispatch<SetStateAction<FilterDraftState>>
  appliedFilters: FilterParams | undefined
  setAppliedFilters: Dispatch<SetStateAction<FilterParams | undefined>>
}

function CsvBulkDownloadModal({
  isOpen,
  onClose,
  filterDraft,
  setFilterDraft,
  appliedFilters,
  setAppliedFilters
}: CsvBulkDownloadModalProps) {
  const { t } = useTranslation()
  const { isAuth } = useContext(UserContext)
  const { isAdmin } = useCanEdit()
  const [csvSamples, setCsvSamples] = useState<SamplesResponseType[]>([])
  const [csvSamplesMeta, setCsvSamplesMeta] = useState<SamplesMeta>({
    total: 0,
    page: 1,
    limit: SAMPLES_PAGE_LIMIT,
    hasMore: false,
    nextPage: null
  })
  const csvSamplesMetaRef = useRef<SamplesMeta>({
    total: 0,
    page: 1,
    limit: SAMPLES_PAGE_LIMIT,
    hasMore: false,
    nextPage: null
  })
  const csvActiveFiltersRef = useRef<FilterParams | undefined>(undefined)
  const [isCsvSamplesLoading, setIsCsvSamplesLoading] = useState(false)
  const sortedSamples = useMemo(() => sortSamplesByCreatedAtDesc(csvSamples), [csvSamples])
  const [selectedSampleIds, setSelectedSampleIds] = useState<string[]>([])
  const [downloadError, setDownloadError] = useState<string>("")
  const [isDownloading, setIsDownloading] = useState(false)
  const [isDownloadCancelHover, setIsDownloadCancelHover] = useState(false)
  const [isDownloadErrorModalOpen, setIsDownloadErrorModalOpen] = useState(false)
  const downloadAbortControllerRef = useRef<AbortController | null>(null)
  const downloadTimeoutIdRef = useRef<number | null>(null)
  const downloadTimeoutHitRef = useRef(false)
  const navigate = useNavigate()

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
  const openFilterModal = useCallback(() => { setIsFilterModalOpen(true) }, [])
  const closeFilterModal = useCallback(() => { setIsFilterModalOpen(false) }, [])
  const closeDownloadErrorModal = useCallback(() => {
    setIsDownloadErrorModalOpen(false)
    setDownloadError("")
  }, [])

  // 追加読み込み時にID重複を避けて既存配列へ結合する
  const mergeCsvSamples = useCallback((current: SamplesResponseType[], next: SamplesResponseType[]) => {
    if (current.length === 0) return next
    const existingIds = new Set(current.map((item) => item.id))
    const merged = [...current]
    next.forEach((item) => {
      if (!existingIds.has(item.id)) {
        merged.push(item)
      }
    })
    return merged
  }, [])

  const refreshCsvSamples = useCallback(async (filters?: FilterParams, options?: { append?: boolean }) => {
    if (!isAuth) {
      return
    }
    const shouldAppend = options?.append ?? false
    const meta = csvSamplesMetaRef.current
    const targetPage = shouldAppend ? (meta.nextPage ?? meta.page + 1) : 1
    if (shouldAppend && !meta.hasMore) {
      return
    }

    const normalizedFilters = !shouldAppend ? (filters ? { ...filters } : undefined) : undefined
    const filtersToUse = shouldAppend ? csvActiveFiltersRef.current : normalizedFilters
    if (!shouldAppend) {
      csvActiveFiltersRef.current = normalizedFilters
    }

    try {
      setIsCsvSamplesLoading(true)
      const result = await fetchDepartmentSamples({
        filters: filtersToUse,
        page: targetPage,
        limit: SAMPLES_PAGE_LIMIT,
        navigate,
        authErrorMode: 'unauthorized-and-forbidden'
      })
      if (!result) {
        return
      }

      const { items, meta: nextMeta } = result
      setCsvSamples((prev) => shouldAppend ? mergeCsvSamples(prev, items) : items)
      setCsvSamplesMeta(nextMeta)
      csvSamplesMetaRef.current = nextMeta
    } catch (error) {
      notifyApiError({ error, logMessage: "CSV一覧の取得に失敗しました。" })
    } finally {
      setIsCsvSamplesLoading(false)
    }
  }, [isAuth, mergeCsvSamples, navigate])

  const loadMoreCsvSamples = useCallback(async () => {
    if (isCsvSamplesLoading || !csvSamplesMetaRef.current.hasMore) {
      return
    }
    await refreshCsvSamples(undefined, { append: true })
  }, [isCsvSamplesLoading, refreshCsvSamples])

  const handleApplyFilter = useCallback((filters: FilterParams) => {
    setAppliedFilters(filters)
    refreshCsvSamples(filters)
    closeFilterModal()
  }, [refreshCsvSamples, closeFilterModal, setAppliedFilters])

  useEffect(() => {
    if (!isOpen || !isAuth) {
      return
    }
    refreshCsvSamples(appliedFilters)
  }, [isOpen, isAuth, refreshCsvSamples, appliedFilters])

  useEffect(() => {
    if (!Array.isArray(csvSamples)) {
      setSelectedSampleIds([])
      return
    }
    setSelectedSampleIds((prev) => prev.filter((id) => csvSamples.some((sample) => sample.id === id)))
  }, [csvSamples])

  const toggleSampleSelection = useCallback((sampleId: string) => {
    setSelectedSampleIds((prev) => {
      if (prev.includes(sampleId)) {
        return prev.filter((id) => id !== sampleId)
      }
      return [...prev, sampleId]
    })
  }, [])

  const selectableSampleIds = useMemo(() => (
    Array.isArray(sortedSamples) ? sortedSamples.map((sample) => sample.id) : []
  ), [sortedSamples])

  const isAllSelected = useMemo(() => (
    selectableSampleIds.length > 0 && selectableSampleIds.every((id) => selectedSampleIds.includes(id))
  ), [selectableSampleIds, selectedSampleIds])

  const handleToggleSelectAll = useCallback(() => {
    if (selectableSampleIds.length === 0) {
      return
    }
    if (isAllSelected) {
      setSelectedSampleIds([])
      return
    }
    setSelectedSampleIds(selectableSampleIds)
  }, [isAllSelected, selectableSampleIds])

  const handleDownloadBulkCsv = useCallback(async () => {
    if (isDownloading) {
      if (downloadAbortControllerRef.current) {
        downloadAbortControllerRef.current.abort()
      }
      return
    }
    setDownloadError("")
    if (selectedSampleIds.length === 0) {
      setDownloadError(t("messages.selectDownloadTarget"))
      setIsDownloadErrorModalOpen(true)
      return
    }
    if (selectedSampleIds.length > MAX_BULK_MEASUREMENT_EXPORT_COUNT) {
      setDownloadError(t("messages.downloadSelectionLimitExceeded", { count: MAX_BULK_MEASUREMENT_EXPORT_COUNT }))
      setIsDownloadErrorModalOpen(true)
      return
    }

    setIsDownloading(true)
    setIsDownloadCancelHover(false)
    downloadTimeoutHitRef.current = false
    const abortController = new AbortController()
    downloadAbortControllerRef.current = abortController
    if (downloadTimeoutIdRef.current !== null) {
      window.clearTimeout(downloadTimeoutIdRef.current)
    }
    downloadTimeoutIdRef.current = window.setTimeout(() => {
      downloadTimeoutHitRef.current = true
      abortController.abort()
    }, CSV_DOWNLOAD_TIMEOUT_MS)

    try {
      const res = await clientFetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/client/measurement-exports`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sample_ids: selectedSampleIds }),
        signal: abortController.signal,
        handleUnauthorized: true
      })

      if (res.status === 401) {
        return
      }
      if (res.status === 403) {
        navigate(PATH_INFO.LOGIN.PATH)
        return
      }

      if (!res.ok) {
        setDownloadError(t("messages.downloadProcessingFailedRetry"))
        setIsDownloadErrorModalOpen(true)
        return
      }

      const blob = await res.blob()
      if (blob.size === 0) {
        setDownloadError(t(INVALID_CONTENT_LENGTH_MESSAGE_KEY))
        setIsDownloadErrorModalOpen(true)
        return
      }
      const disposition = res.headers.get('Content-Disposition')
      const fileName = extractFileNameFromHeader(disposition) ?? DEFAULT_BULK_MEASUREMENT_EXPORT_FILE_NAME
      const downloadUrl = window.URL.createObjectURL(blob)
      const anchor = document.createElement('a')
      anchor.href = downloadUrl
      anchor.download = fileName
      document.body.appendChild(anchor)
      anchor.click()
      anchor.remove()
      window.URL.revokeObjectURL(downloadUrl)
    } catch (error) {
      if (error && (error as { name?: string }).name === 'AbortError') {
        if (downloadTimeoutHitRef.current) {
          setDownloadError(t("messages.downloadTimeoutRetry"))
          setIsDownloadErrorModalOpen(true)
        }
        return
      }
      console.error("一括CSVダウンロードに失敗しました。", error)
      setDownloadError(t("messages.downloadProcessingFailedRetry"))
      setIsDownloadErrorModalOpen(true)
    } finally {
      if (downloadTimeoutIdRef.current !== null) {
        window.clearTimeout(downloadTimeoutIdRef.current)
        downloadTimeoutIdRef.current = null
      }
      downloadAbortControllerRef.current = null
      setIsDownloading(false)
    }
  }, [isDownloading, navigate, selectedSampleIds, t])

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-[1266px] px-[21px] pt-[14px] pb-[30px] max-h-[90vh] flex flex-col'>
      <div className='flex items-center w-full'>
        <div className='w-2 h-[35px] rounded-sm bg-[#3E3E3E] mr-[5px]' ></div>
        <span className='text-[#3E3E3E] text-[16px]'>
          {t("actions.bulkCsvDownload")}
        </span>
      </div>
      <div className='flex justify-end w-full mt-[20px] space-x-2'>
        <button
          onClick={openFilterModal}
          className='flex items-center justify-center w-[160px] h-[47px] border-[2px] border-[#C5C7FF] rounded-[50px] hover:bg-[#C5C7FF] transition-colors'
        >
          <img src={filterDownIcon} alt='sort' className='w-[22px] h-[22px] mr-[5px]' />
          <span className='font-semibold text-[14px] text-[#545899]'>{t("actions.filter")}</span>
        </button>
      </div>
      <div className='flex items-center space-x-[10px]'>
        <button
          className='flex items-center justify-center w-full max-w-[90px] h-[30px] border-[2px] border-[#C5C7FF] rounded-[10px] hover:bg-[#C5C7FF] transition-colors'
          onClick={handleToggleSelectAll}
        >
          <span className='font-semibold text-[12px] text-[#545899]'>{isAllSelected ? t("common.deselect") : t("common.selectAll")}</span>
        </button>
        <span className={`text-[12px] ${selectedSampleIds.length === 0 ? 'text-[#B3B3B3]' : selectedSampleIds.length > MAX_BULK_MEASUREMENT_EXPORT_COUNT ? 'text-[#D32F2F]' : 'text-[#545899]'}`}>
          {t("common.selectedCount", { count: selectedSampleIds.length })}
        </span>
      </div>
      <div
        id={CSV_BULK_MODAL_SCROLL_ID}
        className='flex-1 min-h-0 max-h-[650px] overflow-y-scroll mt-[10px] border-b'
      >
        <InfiniteScroll
          dataLength={sortedSamples?.length ?? 0}
          next={loadMoreCsvSamples}
          hasMore={csvSamplesMeta.hasMore}
          loader={
            <div className='flex items-center justify-center py-3 text-center text-xs text-[#666666]'>
              <ReactLoading type='spin' color='#666666' height={16} width={16} className='inline-block mr-2' />
              <span>{t("common.loadingWithDots")}</span>
            </div>
          }
          endMessage={<div className='py-3 text-center text-xs text-[#666666]'>{t("messages.allDataLoaded")}</div>}
          scrollableTarget={CSV_BULK_MODAL_SCROLL_ID}
          scrollThreshold='200px'
          style={{ overflow: 'visible' }}
        >
          <table className='w-full h-full overflow-auto text-[#666666]'>
            <thead className='sticky top-0'>
              <tr className='[&>th]:bg-[#3E3E3E] [&>th]:text-white [&>th]:font-normal [&>th]:text-xs [&>th]:border desktop-xmd:[&>th]:text-sm'>
                <th className='sticky top-0 w-[43px] h-[39px]'>No</th>
                <th className='sticky top-0 w-[88px]'>{t("common.select")}</th>
                <th className='sticky top-0 w-[145px]'>{t("sample.date")}</th>
                <th className='sticky top-0 w-[145px]'>{t("sample.partNumber")}</th>
                <th className='sticky top-0 w-[173px]'>{t("sample.sampleNumber")}</th>
                <th className='sticky top-0 w-[173px]'>{t("sample.sampleStatus")}</th>
                <th className='sticky top-0 w-[100px]'>{t("sample.repeat")}</th>
                <th className='sticky top-0 w-[100px]'>{t("sample.size")}</th>
                <th className='sticky top-0 w-[130px]'>{t("sample.colorNo")}</th>
                {isAdmin && <th className='sticky top-0 w-[145px]'>{t("sample.department")}</th>}
                <th className='sticky top-0 w-[130px]'>{t("sample.deviceName")}</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(sortedSamples) && sortedSamples?.map((sample, index) => (
                <tr key={sample.id}>
                  <td className='h-[35px] border text-center'>{index + 1}</td>
                  <td className='border'>
                    <div className='flex items-center justify-center w-full h-full'>
                      <label className='cursor-pointer'>
                        <input
                          type="checkbox"
                          name='bulk-check'
                          className='hidden peer'
                          checked={selectedSampleIds.includes(sample.id)}
                          onChange={() => toggleSampleSelection(sample.id)}
                        />
                        <img src={uncheckIcon} alt='uncheck' className='block peer-checked:hidden w-4 h-4 desktop-xmd:w-5 desktop-xmd:h-5' />
                        <img src={checkboxIcon} alt='checked' className='hidden peer-checked:block w-4 h-4 desktop-xmd:w-5 desktop-xmd:h-5' />
                      </label>
                    </div>
                  </td>
                  <td className='border text-xs text-center px-1 desktop-xmd:text-sm'>
                    <SampleDateContent value={sample.created_at} />
                  </td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.part_number || '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.sample_number || '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.kind === 'final' ? 'FINAL' : sample.time !== 0 ? formatOrdinal(sample.time) : '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.repeat || '-'}</td>
                  <td className='border text-[16px] text-center px-1 break-words break-all'>{sample.size || '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.color_no || '-'}</td>
                  {isAdmin && (
                    <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.department_name || '-'}</td>
                  )}
                  <td className='border text-xs text-center px-1 w-[130px] break-words break-all desktop-xmd:text-sm'>
                    <SampleDeviceContent deviceName={sample.device_name} deviceLocation={sample.device_location} />
                  </td>
                </tr>
              ))}
              <tr>
                <td className='border h-full'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                {isAdmin && <td className='border'></td>}
                <td className='border-b'></td>
                <td className='border-x border-b'></td>
              </tr>
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
      <div className='flex items-center justify-center w-full space-x-[10px] mt-[20px]'>
        <button
          className='w-[190px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] font-semibold text-[14px]'
          onClick={onClose}
        >
          {t("common.back")}</button>
        <button
          className={`w-[190px] h-[47px] rounded-[50px] text-[#545899] font-semibold text-[14px] ${isDownloading && isDownloadCancelHover ? 'bg-[#FAD4D4]' : 'bg-[#C5C7FF]'}`}
          onClick={handleDownloadBulkCsv}
          onMouseEnter={() => {
            if (isDownloading) setIsDownloadCancelHover(true)
          }}
          onMouseLeave={() => setIsDownloadCancelHover(false)}
        >
          {isDownloading ? (
            isDownloadCancelHover ? (
              <span>{t("common.downloadCancel")}</span>
            ) : (
              <div className='flex items-center justify-center space-x-2.5'>
                <ReactLoading
                  type='spin'
                  color='#545899'
                  height={20}
                  width={20}
                  className='inline-block ml-2'
                />
                <span>{t("common.downloading")}</span>
              </div>
            )
          ) : t("common.download")}
        </button>
      </div>
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={closeFilterModal}
        onApplyFilter={handleApplyFilter}
        draft={filterDraft}
        setDraft={setFilterDraft}
      />
      <DownloadErrorModal
        isOpen={isDownloadErrorModalOpen && Boolean(downloadError)}
        onClose={closeDownloadErrorModal}
        message={downloadError}
      />
    </Modal>
  )
}

function DownloadErrorModal({ isOpen, onClose, message }: { isOpen: boolean, onClose: () => void, message: string }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-[600px] h-[200px] flex flex-col items-center justify-center'>
      <span className='text-center text-[14px] text-[#3E3E3E]'>{message}</span>
      <button
        className='mt-[25px] w-[160px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] font-semibold text-[14px]'
        onClick={onClose}
      >
        OK
      </button>
    </Modal>
  )
}
